import { colors } from 'ui/theme/colors';
import { SvgIcon, SvgIconProps } from '../SvgIcon';
import { getColor } from '../utils';

export const TV = ({
  height = 24,
  width = 24,
  color = colors.secondaryText,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon
    data-temporary-fix
    height={height}
    width={width}
    viewBox="0 0 16 16"
    color={color}
    {...props}
  >
    <path
      fill={getColor(color, isColorInherited)}
      d="M12.2109 1.00378C11.1499 1.00378 10.132 1.41588 9.32554 2.15332C9.08914 2.36949 9.07274 2.73638 9.28891 2.97278C9.50508 3.20918 9.87197 3.22558 10.1084 3.00941C10.7136 2.45599 11.4562 2.16383 12.2109 2.16383C12.9655 2.16383 13.7081 2.45599 14.3133 3.00941C14.5497 3.22558 14.9166 3.20918 15.1328 2.97278C15.349 2.73637 15.3326 2.36949 15.0962 2.15332C14.2897 1.41588 13.2718 1.00378 12.2109 1.00378Z"
    />
    <path
      fill={getColor(color, isColorInherited)}
      d="M11.0662 4.22671C11.3862 3.98285 11.7902 3.84661 12.211 3.84661C12.6318 3.84661 13.0357 3.98285 13.3558 4.22671C13.6106 4.42086 13.9745 4.37171 14.1687 4.11692C14.3628 3.86212 14.3137 3.49818 14.0589 3.30402C13.5319 2.90243 12.8795 2.68656 12.211 2.68656C11.5424 2.68656 10.8901 2.90243 10.3631 3.30402C10.1083 3.49818 10.0591 3.86212 10.2533 4.11692C10.4475 4.37171 10.8114 4.42086 11.0662 4.22671Z"
    />
    <path
      fill={getColor(color, isColorInherited)}
      d="M3.18532 4.7254C2.84978 4.7254 2.57777 4.99741 2.57777 5.33294V11.2708C2.57777 11.6063 2.84978 11.8783 3.18532 11.8783H12.0921C12.4276 11.8783 12.6996 11.7512 12.6996 11.4156C12.6996 11.0953 12.9593 10.8356 13.2797 10.8356C13.6 10.8356 13.8597 11.0953 13.8597 11.4156C13.8597 12.3918 13.0683 13.0384 12.0921 13.0384H11.2702L11.4731 13.3897C11.6332 13.6671 11.5382 14.0219 11.2608 14.1821C10.9833 14.3422 10.6286 14.2472 10.4684 13.9698L9.93071 13.0384H5.4322L4.85484 14.0384C4.69467 14.3158 4.33993 14.4109 4.06251 14.2507C3.78509 14.0906 3.69004 13.7358 3.85021 13.4584L4.0927 13.0384H3.18532C2.2091 13.0384 1.41772 12.247 1.41772 11.2708V5.33294C1.41772 4.35673 2.2091 3.56535 3.18532 3.56535H8.62406C8.9444 3.56535 9.20408 3.82504 9.20408 4.14537C9.20408 4.46571 8.9444 4.7254 8.62406 4.7254H3.18532Z"
    />
    <path
      fill={getColor(color, isColorInherited)}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.303 5.76411C10.303 5.19233 10.8058 4.75128 11.397 4.75128H13.1189C13.7101 4.75128 14.2129 5.19233 14.2129 5.76411V9.30525C14.2129 9.87704 13.7101 10.3181 13.1189 10.3181H11.397C10.8058 10.3181 10.303 9.87704 10.303 9.30525V5.76411ZM11.397 5.70674C11.3416 5.70674 11.3202 5.74484 11.3202 5.76411V9.30525C11.3202 9.32453 11.3416 9.36263 11.397 9.36263H13.1189C13.1743 9.36263 13.1958 9.32453 13.1958 9.30525V5.76411C13.1958 5.74484 13.1743 5.70674 13.1189 5.70674H11.397Z"
    />
  </SvgIcon>
);
